"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var subevent_1 = require("./subevent");
var event_info_json_1 = require("./event-info-json");
var SubEventJson = /** @class */ (function () {
    function SubEventJson() {
    }
    SubEventJson.fromJson = function (json) {
        json = json || {};
        var subEvent = new subevent_1.SubEvent(json.parent);
        subEvent.info = event_info_json_1.EventInfoJson.fromJson(json.info);
        return utils_1.factory(subEvent, json || {});
    };
    SubEventJson = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], SubEventJson);
    return SubEventJson;
}());
exports.SubEventJson = SubEventJson;
//# sourceMappingURL=subevent-json.js.map